export enum WebSocketEventType {
  PING = 'ping',
  PONG = 'pong',
  AUTH_SUCCESS = 'auth_success',
  AUTH_FAILED = 'auth_failed',
  INVOKE = 'invoke',
  STREAM_START = 'stream_start',
  MESSAGE = 'message',
  TOOL_CALL = 'tool_call',
  TOOL_RESULT = 'tool_result',
  CONVERSATION_STATE = 'conversation_state',
  STREAM_COMPLETE = 'stream_complete',
  STREAM_ERROR = 'stream_error',
  INITIALIZATION_ERROR = 'initialization_error',
  CHUNK_ERROR = 'chunk_error',
  END = 'end',
  CAD_GEOMETRY_CREATE = 'cad_geometry_create',
  CAD_GEOMETRY_TRANSFORM = 'cad_geometry_transform',
  CAD_BOOLEAN_OPERATION = 'cad_boolean_operation',
  CAD_DELETE_GEOMETRY = 'cad_delete_geometry',
  TOOL = 'tool',
  TRACE = 'trace',
  ERROR = 'error',
  NOTIFICATION = 'notification',
  UPDATE = 'update',
  MAINTENANCE_STATUS = 'maintenance_status',
  SEAT_STATUS_CHANGED = 'seat_status_changed'
}

export enum WebSocketConnectionState {
  DISCONNECTED = 'disconnected',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  RECONNECTING = 'reconnecting',
  ERROR = 'error',
  CLOSED = 'closed'
}

export interface WebSocketMessage<T = any> {
  type?: string;
  event: string;
  data: T;
  timestamp?: number;
  id?: string;
}

export interface StreamStartMessage {
  event: WebSocketEventType.STREAM_START;
  message: {
    sessionId: string;
    projectId: string;
    currentStep: string;
    innerStep: string;
  };
}

export interface AIMessage {
  event: WebSocketEventType.MESSAGE;
  message: {
    content: string;
    type: 'ai';
  };
}

export interface ToolCallMessage {
  event: WebSocketEventType.TOOL_CALL;
  message: {
    content: string;
    tool_calls: Array<{
      id: string;
      name: string;
      args: unknown;
    }>;
    type: 'ai';
  };
}

export interface ToolResultMessage {
  event: WebSocketEventType.TOOL_RESULT;
  message: {
    content: string;
    name: string;
    tool_call_id: string;
    type: 'tool';
  };
}

export interface ConversationStateMessage {
  event: WebSocketEventType.CONVERSATION_STATE;
  message: {
    messages: Array<{
      type: 'human' | 'ai' | 'tool' | 'system';
      content: string;
      tool_calls?: Array<{
        id: string;
        name: string;
        args: unknown;
      }>;
      name?: string;
      tool_call_id?: string;
    }>;
    currentStep: string;
    innerStep: string;
  };
}
